import Modal from 'backbone-modal';
import CartItemsModal from './cartItemsModal';
import selectors from './selectors';

const modalView = (
    typeof Modal === 'function'
    && $(selectors.template.cart).length
  )
    ? new CartItemsModal()
    : false;

export default modalView;
